import React from "react";
import { connect } from "react-redux";
import { areas } from "../properties";
import { cargarDatosPersonales, guardarAreaOcupacion, guardarMedios, generarOtp } from "./datos.act";
import ModalCodigoVerificacion from "./modalCodigoVerificacion.cmpt";
import { validacionEmail, validacionTel } from "./servicios.act";
import { goTo } from "../tools";
import { database as db, authentication as auth } from "../app-database";

const mapState = (state) => {
	return {
		usuario: state.miPerfil.usuario,
		lada: state.miPerfil.lada,
		celular: state.miPerfil.celular,
		ladaFijo: state.miPerfil.ladaFijo,
		telefono: state.miPerfil.telefono,
		ocupacion: state.miPerfil.ocupacion,
		areaDeInteres: state.miPerfil.areaDeInteres,
		objTemporal: state.miPerfil.objTemporal,
		editing: state.miPerfil.editingDP
	};
};

const mapDispatch = (dispatch) => {
	return {
		setTemporal: (obj) => {
			dispatch({ "type": "MI_PERFIL_SET_OBJ_TEMPORAL", "obj": obj });
		},
		changeEditing: (flag) => {
			dispatch({ "type": "MI_PERFIL_CHANGE_EDITING_DP", "flag": flag });
		},
		cargarDatosPersonales: () => {
			dispatch(cargarDatosPersonales());
		},
		guardarAreaOcupacion: (datos) => {
			dispatch(guardarAreaOcupacion(datos));
		},
		guardarMedios: (datos) => {
			dispatch(guardarMedios(datos));
		},
		generarOtp: (num) => {
			dispatch(generarOtp(num));
		},
		setDatosOtp: (num, mail) => {
			dispatch({ "type": "MI_PERFIL_SET_DATOS_OTP", numero: num, correo: mail });
		},
		resetPaso: () => {
			dispatch({ "type": "MI_PERFIL_RESET_SIGUIENTE_CODIGO" });
		},
		addEvento: (evento) => {
			dispatch({ "type": "MI_PERFIL_SET_EVENT", "evento": evento });
		},
		setTelefonoFijo: (lada, tel) => {
			dispatch({ "type": "MI_PERFIL_SET_DT_TFIJO", ladaFijo: lada, telefono: tel });
		}
	};
};

const modal1 = "#modal-validacion1";
const modal2 = "#modal-validacion2";

class DatosPersonales extends React.Component {
	contadorEmail = 0;
	contadorCel = 0;
	contadorFijo = 0;
	cambioEmail = false;
	cambioCel = false;
	cambioFijo = false;
	correosValidados = [];
	telefonosValidados = [];
	ladaCel = '';
	ladaFijo = '';
	secondError = false;

	state = {
		inputUsuarioActive: "input-active",
		inputUsuarioConfirmActive: "input-active",
		inputLadaActive: "input-active",
		inputCelularActive: "input-active",
		inputLadaFijoActive: "input-active",
		inputTelefonoActive: "input-active",
		inputOcupacionActive: "input-active",
		inputAreaDeInteresActive: "input-active",
		errorUsuarioMsj: "",
		errorUsuarioCMsj: "",
		errorCelMsj: "",
		errorTelMsj: "",
		checkFlag: false,
		tituloOne: "",
		mensajeOne: "",
		tituloTwo: "",
		mensajeTwo: "",
		datosClass: "",
	}

	componentWillUnmount() {
		this.props.changeEditing(false);
	}

	validateEmail = (email) => {
		var pattern = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
		return pattern.test(email);
	}

	edit = () => {
		if (this.props.editing) {
			this.props.addEvento("Cancelar-DatosPersonales");
		}
		this.setState({ errorusuario: false });
		this.setState({ errorusuarioC: false });
		this.setState({ errorlada: false });
		this.setState({ errorcelular: false });
		this.setState({ errorladaF: false });
		this.setState({ errortelefono: false });
		this.setState({ errorocupacion: false });
		this.setState({ errorarea: false });
		this.setState({ inputUsuarioActive: this.props.usuario ? "input-active" : "" });
		this.setState({ inputUsuarioConfirmActive: this.props.usuario ? "input-active" : "" });
		this.setState({ inputLadaActive: this.props.lada ? "input-active" : "" });
		this.setState({ inputCelularActive: this.props.celular ? "input-active" : "" });
		this.setState({ inputLadaFijoActive: this.props.ladaFijo ? "input-active" : "" });
		this.setState({ inputTelefonoActive: this.props.telefono ? "input-active" : "" });
		this.props.changeEditing(!this.props.editing);
	}

	startSave = () => {
		setTimeout(() => {
			this.save();
		}, 3000);
	}

	continuar = () => {
		setTimeout(() => {
			this.save();
		}, 1000);
	}

	save = () => {
		if (this.secondError) {
			console.log("Empezará a guardar");
			if (this.props.editing) {
				this.props.addEvento("Guardar-DatosPersonales");
			}
			this.setState({ checkFlag: true });
			let obj = {
				flag: "dp",
				usuario: this.refs.usr.value,
				usuarioC: this.refs.usrC.value,
				lada: this.refs.ld.value,
				celular: this.refs.cel.value,
				ladaF: this.refs.ldF.value,
				telefono: this.refs.tel.value,
				ocupacion: this.refs.ocu.value,
				area: this.refs.aI.value
			};
			obj.usuario = obj.usuario.toLowerCase();
			obj.usuarioC = obj.usuarioC.toLowerCase();
			console.log(`Usuario ${obj.usuario} y UsuarioC ${obj.usuarioC}`);
			let ok = true;
			for (var key in obj) {
				if (!obj[key]) {
					switch (key) {
						case "usuario":
							this.setState({ errorusuario: true });
							this.setState({ errorUsuarioMsj: "Campo requerido." });
							ok = false;
							break;
						case "usuarioC":
							this.setState({ errorusuarioC: true });
							this.setState({ errorUsuarioCMsj: "Campo requerido." });
							ok = false;
							break;
						case "lada":
							this.setState({ errorcelular: true });
							this.setState({ errorCelMsj: "Campo Lada requerido." });
							ok = false;
							break;
						case "celular":
							this.setState({ errorcelular: true });
							ok = false;
							break;
					}
				}
			}
			let ocupac = obj.ocupacion.trim();
			if (obj.ocupacion && ocupac.length == 0) {
				this.setState({ errorocupacion: true });
				ok = false;
			}
			if (obj.usuario && !this.validateEmail(obj.usuario)) {
				this.setState({ errorusuario: true });
				this.setState({ errorUsuarioMsj: "El formato no es válido. Favor de verificarlo." });
				ok = false;
			}
			if (obj.usuarioC && !this.validateEmail(obj.usuarioC)) {
				this.setState({ errorusuarioC: true });
				this.setState({ errorUsuarioCMsj: "El formato no es válido. Favor de verificarlo." });
				ok = false;
			}
			if (obj.usuario && obj.usuarioC && obj.usuario != obj.usuarioC) {
				this.setState({ errorusuarioC: true });
				this.setState({ errorUsuarioCMsj: "El correo electrónico no coincide. Favor de verificar." });
				ok = false;
			}
			let celCompleto = obj.lada.substring(1, obj.lada.length) + obj.celular;
			if (celCompleto.length != 10) {
				ok = false;
				this.setState({ errorcelular: true });
				this.setState({ errorCelMsj: "Tu teléfono celular es incorrecto. Verifica que sean 10 dígitos incluyendo lada nacional." });
			}
			let telCompleto = obj.ladaF.substring(1, obj.ladaF.length) + obj.telefono;
			if (obj.ladaF.length > 0 && obj.telefono.length > 0) {
				if (telCompleto.length != 10) {
					ok = false;
					this.setState({ errortelefono: true });
					this.setState({ errorTelMsj: "Tu teléfono fijo es incorrecto. Verifica que sean 10 dígitos incluyendo lada nacional." });
				}
			}
			if (telCompleto === celCompleto) {
				ok = false;
				this.setState({ errortelefono: true });
				this.setState({ errorTelMsj: "Tu número de teléfono debe ser diferente." });
			}
			if (obj.ladaF.length > 0 && obj.telefono.length == 0) {
				ok = false;
				this.setState({ errortelefono: true });
				this.setState({ errorTelMsj: "Campo requerido." });
			}
			if (obj.ladaF.length == 0 && obj.telefono.length > 0) {
				ok = false;
				this.setState({ errortelefono: true });
				this.setState({ errorTelMsj: "Campo Lada requerido." });
			}
			if (ok) {
				let cc = obj.lada.substring(1, obj.lada.length) + obj.celular;
				let tc = obj.ladaF.substring(1, obj.ladaF.length) + obj.telefono;
				let occ = this.props.lada.substring(1, this.props.lada.length) + this.props.celular;
				let otc = this.props.ladaFijo.substring(1, this.props.ladaFijo.length) + this.props.telefono;
				if (obj.usuario != this.props.usuario || cc != occ) {
					this.props.resetPaso();
					if (obj.lada.indexOf("+") !== -1) {
						obj.lada = obj.lada.substring(1, obj.lada.length);
					}
					if (obj.ladaF.indexOf("+") !== -1) {
						obj.ladaF = obj.ladaF.substring(1, obj.ladaF.length);
					}
					console.log("Se mandará otp a: " + cc + " y a: " + obj.usuario);
					this.props.setDatosOtp(cc, obj.usuario);
					this.props.setTemporal(obj);
					$("#modal-codigo-dp").modal("toggle");
				}
				else if (this.props.ladaFijo != this.refs.ldF.value || this.props.telefono != this.refs.tel.value) {
					//Se guarda el teléfono fijo
					let tempObj = {
						usuario: this.props.usuario,
						lada: this.props.lada,
						celular: this.props.celular,
						ladaF: this.refs.ldF.value,
						telefono: this.refs.tel.value,
					};
					this.props.guardarMedios(tempObj);
				}
				this.props.guardarAreaOcupacion(obj);
			}
		}
		this.secondError = false;
	}

	validarEmail = (valorEmail) => {
		const email = valorEmail.target.value;
		if (this.cambioEmail && (email !== "" && this.validateEmail(email))) {
			if (!this.correosValidados.hasOwnProperty(email)) {
				validacionEmail(email)
					.then(response => {
						const isValid = response.data;
						this.correosValidados[email] = isValid;

						if (isValid) {
							this.secondError = true;
							console.log("VALIDACIÓN EN LINEA CORREO:", isValid);
						} else {
							this.countEmail();
						}
					})
			} else {
				console.log("EL CORREO YA ESTA VALIDADO", this.correosValidados);
				if (!this.correosValidados[email]) {
					this.countEmail();
				}
			}
		} else {
			console.log("El correo electrónico no ha cambiado, no cumple con el formato o esta vacio, no se valida.");
		}
	}

	countEmail = () => {
		this.contadorEmail++;
		if (this.contadorEmail === 1) {
			this.setState({ tituloOne: "Error en el correo electrónico.", mensajeOne: "El correo electrónico no es válido. Favor de verificar." });
			$(modal1).modal("toggle");
			$('#usuario').val('');
		} else if (this.contadorEmail === 2) {
			this.secondError = true;
			this.setState({
				tituloTwo: "Error en el correo electrónico.",
				mensajeTwo: "El correo electrónico sigue identificado como inválido. Da clic en continuar para seguir adelante con el trámite."
			});
			$(modal2).modal("toggle");
			this.contadorEmail = 0;
		}
	}

	validarCelular = (valorCel) => {
		this.ladaCel = (this.refs.ld.value).substr(1, 3);
		const celComp = this.ladaCel + valorCel.target.value;
		if (this.cambioCel && (celComp !== "" && celComp.length === 10)) {
			if (!this.telefonosValidados.hasOwnProperty(celComp)) {
				validacionTel(celComp)
					.then(response => {
						const isValid = response.data.validacionMedioContacto;
						this.telefonosValidados[celComp] = isValid;

						if (isValid) {
							this.secondError = true;
							console.log("VALIDACIÓN EN LINEA CELULAR:", isValid, response.data);
						} else {
							this.countCelular();
						}
					})
			} else {
				console.log("EL CELULAR YA ESTA VALIDADO", this.telefonosValidados);
				if (!this.telefonosValidados[celComp]) {
					this.countCelular();
				}
			}
		} else {
			console.log("El teléfono celular no ha cambiado, no cumple con el formato o esta vacio, no se valida.");
		}
	}

	countCelular = () => {
		this.contadorCel++;
		if (this.contadorCel === 1) {
			this.setState({ tituloOne: "Error en el teléfono celular.", mensajeOne: "El teléfono celular no es válido. Favor de verificar." });
			$(modal1).modal("toggle");
			$('#lada').val('');
			$('#celular').val('');
		} else if (this.contadorCel === 2) {
			this.secondError = true;
			this.setState({
				tituloTwo: "Error en el teléfono celular.",
				mensajeTwo: "El teléfono celular sigue identificado como inválido. Da clic en continuar para seguir adelante con el trámite."
			});
			$(modal2).modal("toggle");
			this.contadorCel = 0;
		}
	}

	validarFijo = (valorFijo) => {
		this.ladaFijo = (this.refs.ldF.value).substr(1, 3);
		const telComp = this.ladaFijo + valorFijo.target.value;
		if (this.cambioFijo && (telComp !== "" && telComp.length === 10)) {
			if (!this.telefonosValidados.hasOwnProperty(telComp)) {
				validacionTel(telComp)
					.then(response => {
						const isValid = response.data.validacionMedioContacto;
						this.telefonosValidados[telComp] = isValid;

						if (isValid) {
							this.secondError = true;
							console.log("VALIDACIÓN EN LINEA FIJO:", isValid, response.data);
						} else {
							this.countFijo();
						}
					})
			} else {
				console.log("EL TELEFONO YA ESTA VALIDADO", this.telefonosValidados);
				if (!this.telefonosValidados[telComp]) {
					this.countFijo();
				}
			}
		} else {
			console.log("El teléfono fijo no ha cambiado, no cumple con el formato o esta vacio, no se valida.");
		}
	}

	countFijo = () => {
		this.contadorFijo++;
		if (this.contadorFijo === 1) {
			this.setState({ tituloOne: "Error en el teléfono fijo.", mensajeOne: "El teléfono fijo no es válido. Favor de verificar." });
			$(modal1).modal("toggle");
			$('#ladaFijo').val('');
			$('#telefono').val('');
		} else if (this.contadorFijo === 2) {
			this.secondError = true;
			this.setState({
				tituloTwo: "Error en el teléfono fijo.",
				mensajeTwo: "El teléfono fijo sigue identificado como inválido. Da clic en continuar para seguir adelante con el trámite."
			});
			$(modal2).modal("toggle");
			this.contadorFijo = 0;
		}
	}

	handleBlur = (event) => {
		let id = event.target.id;
		let value = event.target.value;
		switch (id) {
			case "usuario":
				this.setState({ inputUsuarioActive: value ? "input-active" : "" });
				this.validarEmail(event);
				break;
			case "usuarioConfirm":
				this.setState({ inputUsuarioConfirmActive: value ? "input-active" : "" });
				break;
			case "lada":
				this.setState({ inputLadaActive: value ? "input-active" : "" });
				break;
			case "celular":
				this.setState({ inputCelularActive: value ? "input-active" : "" });
				this.validarCelular(event);
				break;
			case "ladaFijo":
				this.setState({ inputLadaFijoActive: value ? "input-active" : "" });
				break;
			case "telefono":
				this.setState({ inputTelefonoActive: value ? "input-active" : "" });
				this.validarFijo(event);
				break;
			case "ocupacion":
				this.setState({ inputOcupacionActive: value ? "input-active" : "" });
				break;
			case "areaDeInteres":
				this.setState({ inputAreaDeInteresActive: value ? "input-active" : "" });
				break;
		}
	}

	handleFocus = (event) => {
		let id = event.target.id;
		switch (id) {
			case "usuario":
				this.setState({ inputUsuarioActive: "input-active" });
				this.setState({ errorusuario: false });
				this.setState({ errorUsuarioMsj: "" })
				break;
			case "usuarioConfirm":
				this.setState({ inputUsuarioConfirmActive: "input-active" });
				this.setState({ errorusuarioC: false });
				this.setState({ errorUsuarioCMsj: "" });
				break;
			case "lada":
				this.setState({ inputLadaActive: "input-active" });
				this.setState({ errorlada: false });
				break;
			case "celular":
				this.setState({ inputCelularActive: "input-active" });
				this.setState({ errorcelular: false });
				break;
			case "ladaFijo":
				this.setState({ inputLadaFijoActive: "input-active" });
				this.setState({ errorladaF: false });
				break;
			case "telefono":
				this.setState({ inputTelefonoActive: "input-active" });
				this.setState({ errortelefono: false });
				break;
			case "ocupacion":
				this.setState({ inputOcupacionActive: "input-active" });
				this.setState({ errorocupacion: false });
				break;
			case "areaDeInteres":
				this.setState({ inputAreaDeInteresActive: "input-active" });
				this.setState({ errorarea: false });
				break;
		}
	}

	componentDidMount = () => {
		this.cargarDatos();
	}

	cargarDatos = () => {
		console.log("CARGAR", auth.currentUser.uid);
		db.ref("miPerfil/" + auth.currentUser.uid).once(
			"value",
			(snapshot) => {
				const data = snapshot.val();
				console.log("Data", data);
				const celularComleto = data.datosPersonales.ladaCelular + data.datosPersonales.numeroCelular;
				const telefonoCompleto = data.datosPersonales.ladaFijo + data.datosPersonales.numeroFijo;
				this.props.setTelefonoFijo(data.datosPersonales.ladaFijo, data.datosPersonales.numeroFijo);
				this.setState({ ocupacion: data.datosPersonales.ocupacion });
				this.setState({ usuario: data.datosPersonales.usuario });
				this.setState({ celular: celularComleto });
				this.setState({ telefono: telefonoCompleto });

				switch (parseInt(data.datosPersonales.areaInteres)) {
					case 1: this.setState({ areaDeInteres: "Arquitectura/Construcción" });
						break;
					case 2: this.setState({ areaDeInteres: "Autos" });
						break;
					case 3: this.setState({ areaDeInteres: "Cine" });
						break;
					case 4: this.setState({ areaDeInteres: "Cocina, Alimentos" });
						break;
					case 5: this.setState({ areaDeInteres: "Coleccionista" });
						break;
					case 6: this.setState({ areaDeInteres: "Cultura" });
						break;
					case 7: this.setState({ areaDeInteres: "Deportes" });
						break;
					case 8: this.setState({ areaDeInteres: "Economía, Contabilidad y Finanzas" });
						break;
					case 9: this.setState({ areaDeInteres: "Educación Académica" });
						break;
					case 10: this.setState({ areaDeInteres: "Entretenimiento" });
						break;
					case 11: this.setState({ areaDeInteres: "Hogar" });
						break;
					case 12: this.setState({ areaDeInteres: "Jurídico" });
						break;
					case 13: this.setState({ areaDeInteres: "Lectura" });
						break;
					case 14: this.setState({ areaDeInteres: "Manualidades" });
						break;
					case 15: this.setState({ areaDeInteres: "Marketing" });
						break;
					case 16: this.setState({ areaDeInteres: "Medicina y Salud" });
						break;
					case 17: this.setState({ areaDeInteres: "Moda" });
						break;
					case 18: this.setState({ areaDeInteres: "Música" });
						break;
					case 19: this.setState({ areaDeInteres: "Negocios" });
						break;
					case 20: this.setState({ areaDeInteres: "Opera" });
						break;
					case 21: this.setState({ areaDeInteres: "Seguros y Pensiones" });
						break;
					case 22: this.setState({ areaDeInteres: "Teatro" });
						break;
					case 23: this.setState({ areaDeInteres: "Tecnología" });
						break;
					case 24: this.setState({ areaDeInteres: "Viajes" });
						break;
				}
			},
			(reason) => {
				throw reason;
			});
	}



	handleChange = (event) => {
		let id = event.target.id;
		let value = event.target.value;
		let tamano;
		let ultimo;
		let completo;
		let primero;

		switch (id) {
			case 'usuario':
			case 'usuarioConfirm':
				event.target.value = event.target.value.replace(' ', '');
				this.cambioEmail = true;
				break;
			case "lada":
				tamano = event.target.value.length;
				ultimo = value[value.length - 1];
				value = event.target.value;
				primero = value[0];
				if (primero != "+") {
					value = "+" + value;
					event.target.value = value;
					tamano = event.target.value.length;
					ultimo = value[value.length - 1];
				}
				if (isNaN(ultimo) && tamano == 2) {
					event.target.value = "";
					tamano = event.target.value.length;
					value = event.target.value;
				}
				if (tamano == 1) {
					event.target.value = "";
					break;
				}
				if (value) {
					for (var i = 1; i < value.length; i++) {
						if (value[i] != "+" && (isNaN(value[i]) || value[i] == " ")) {
							event.target.value = value.replace(value[i], "");
							value = event.target.value;
							i = -1;
						}
					};
				}
				break;
			case "celular":
				ultimo = value[value.length - 1];
				if (value) {
					for (var i = 0; i < value.length; i++) {
						if (isNaN(value[i]) || value[i] == " ") {
							event.target.value = value.replace(value[i], "");
							value = event.target.value;
							i = -1;
						}
					};
				}
				this.cambioCel = true;
				break;
			case "ladaFijo":
				tamano = event.target.value.length;
				ultimo = value[value.length - 1];
				value = event.target.value;
				primero = value[0];
				if (primero != "+") {
					value = "+" + value;
					event.target.value = value;
					tamano = event.target.value.length;
					ultimo = value[value.length - 1];
				}
				if (isNaN(ultimo) && tamano == 2) {
					event.target.value = "";
					tamano = event.target.value.length;
					value = event.target.value;
				}
				if (tamano == 1) {
					event.target.value = "";
					break;
				}
				if (value) {
					for (var i = 1; i < value.length; i++) {
						if (value[i] != "+" && (isNaN(value[i]) || value[i] == " ")) {
							event.target.value = value.replace(value[i], "");
							value = event.target.value;
							i = -1;
						}
					};
				}
				break;
			case "telefono":
				ultimo = value[value.length - 1];
				if (value) {
					for (var i = 0; i < value.length; i++) {
						if (isNaN(value[i]) || value[i] == " ") {
							event.target.value = value.replace(value[i], "");
							value = event.target.value;
							i = -1;
						}
					};
				}
				this.cambioFijo = true;
				break;
		}
		if (this.state.checkFlag) {
			switch (id) {
				case "usuario":
					if (!value) {
						this.setState({ errorusuario: true });
						this.setState({ errorUsuarioMsj: "Campo requerido." });
					} else {
						if (value) {
							this.setState({ errorusuario: false });
							this.setState({ errorUsuarioMsj: "" });
						}
						if (value && value != this.refs.usrC.value) {
							this.setState({ errorusuarioC: true });
							this.setState({ errorUsuarioCMsj: "El correo electrónico no coincide. Favor de verificar." });
						} else {
							this.setState({ errorusuarioC: false });
							this.setState({ errorUsuarioCMsj: "" });
						}
					}
					break;
				case "usuarioConfirm":
					if (!value) {
						this.setState({ errorusuarioC: true });
						this.setState({ errorUsuarioCMsj: "Campo requerido." });
					} else {
						if (value && value != this.refs.usr.value) {
							this.setState({ errorusuarioC: true });
							this.setState({ errorUsuarioCMsj: "El correo electrónico no coincide. Favor de verificar." });
						} else {
							this.setState({ errorusuarioC: false });
							this.setState({ errorUsuarioCMsj: "" });
						}
					}
					break;
				case "lada":
					completo = value.substring(1, value.length) + this.refs.cel.value;
					var completoFijo = this.refs.ldF.value.substring(1, this.refs.ldF.value.length) + this.refs.tel.value;
					if (!value) {
						this.setState({ errorcelular: true });
						this.setState({ errorCelMsj: "Campo Lada requerido." });
					} else {
						if (value && completo.length != 10) {
							this.setState({ errorcelular: true });
							this.setState({ errorCelMsj: "Tu teléfono celular es incorrecto. Verifica que sean 10 dígitos incluyendo lada nacional." });
						} else if (completo === completoFijo) {
							this.setState({ errortelefono: true });
							this.setState({ errorTelMsj: "Tu número de teléfono debe ser diferente." });
						} else {
							this.setState({ errorcelular: false });
							this.setState({ errorCelMsj: "" });
							this.setState({ errortelefono: false });
							this.setState({ errorTelMsj: "" });
						}
					}
					break;
				case "celular":
					completo = this.refs.ld.value.substring(1, this.refs.ld.value.length) + value;
					var completoFijo = this.refs.ldF.value.substring(1, this.refs.ldF.value.length) + this.refs.tel.value;
					if (!value) {
						this.setState({ errorcelular: true });
						this.setState({ errorCelMsj: "Campo requerido." });
					} else {
						if (value && completo.length != 10) {
							this.setState({ errorcelular: true });
							this.setState({ errorCelMsj: "Tu teléfono celular es incorrecto. Verifica que sean 10 dígitos incluyendo lada nacional." });
						} else if (completo === completoFijo) {
							this.setState({ errortelefono: true });
							this.setState({ errorTelMsj: "Tu número de teléfono debe ser diferente." });
						}
						else {
							this.setState({ errorcelular: false });
							this.setState({ errorCelMsj: "" });
							this.setState({ errortelefono: false });
							this.setState({ errorTelMsj: "" });
						}
					}
					break;
				case "ladaFijo":
					completo = value.substring(1, value.length) + this.refs.tel.value;
					var completoCelular = this.refs.ld.value.substring(1, this.refs.ld.value.length) + this.refs.cel.value;
					if (value && completo.length != 10) {
						this.setState({ errortelefono: true });
						this.setState({ errorTelMsj: "Tu teléfono fijo es incorrecto. Verifica que sean 10 dígitos incluyendo lada nacional." });
					} else if (completoCelular === completo) {
						this.setState({ errortelefono: true });
						this.setState({ errorTelMsj: "Tu número de teléfono debe ser diferente." });
					}
					else {
						this.setState({ errortelefono: false });
						this.setState({ errorTelMsj: "" });
					}
					break;
				case "telefono":
					completo = this.refs.ldF.value.substring(1, this.refs.ldF.value.length) + value;
					var completoCelular = this.refs.ld.value.substring(1, this.refs.ld.value.length) + this.refs.cel.value;
					if (this.refs.ldF.value.length == 0 && value.length > 0) {
						this.setState({ errortelefono: true });
						this.setState({ errorTelMsj: "Campo Lada requerido." });
					} else if (this.refs.ldF.value.length > 0 && value.length == 0) {
						this.setState({ errortelefono: true });
						this.setState({ errorTelMsj: "Campo requerido." });
					} else if (value && completo.length != 10) {
						this.setState({ errortelefono: true });
						this.setState({ errorTelMsj: "Tu teléfono fijo es incorrecto. Verifica que sean 10 dígitos incluyendo lada nacional." });
					}
					else if (completoCelular === completo) {
						this.setState({ errortelefono: true });
						this.setState({ errorTelMsj: "Tu número de teléfono debe ser diferente." });
					} else {
						this.setState({ errortelefono: false });
						this.setState({ errorTelMsj: "" });
					}
					break;
				case "ocupacion":
					break;
			}
		}
	}

	_handleKeyPress = (event) => {
		if (event.key === "Enter") {
			this.startSave();
		}
	}

	pickClass = (sRuta) => {
		if (sRuta) {
			goTo(sRuta);
		}
	}

	render() {
		var Areas = areas,
			MakeItem = function (X) {
				return <option key={X.id} value={X.id}>{X.area}</option>;
			};
		return <div className="col-xs-12">
			<div className="card perfil-card">
				<div className="card-header">
					<div className="row">
						<div className="col-xs-6">
							<i><img src={require("../img/datos-personales.svg")} /></i><b>Datos personales</b>
						</div>
						<div className="col-xs-6">
							<div className="text-right card-actions-btn">
								{!this.props.editing &&
									<a id="dp_edit" onClick={this.pickClass.bind(this, "datos-personales")} className="orange-btn">Editar<img src={require("../img/editar-icono.png")} /></a>
								}
								{this.props.editing &&
									<div>
										<a id="dp_cancel" onClick={this.edit} className="pad-right-10">Cancelar</a>
										<a id="dp_acept" onClick={this.startSave} className="orange-btn">Guardar</a>
									</div>
								}
							</div>
						</div>
					</div>
				</div>
				<div className="row">
					<div className="col-xs-12">
						{!this.props.editing &&
							<div className="input-wrap">
								<label>Usuario</label>
								<span className="blue-text">
									<p><b>{this.props.usuario.length > 27 ? this.props.usuario.substring(0, 27) + "..." : this.props.usuario}</b></p>
								</span>
							</div>
						}
						{this.props.editing &&
							<div className="row">
								<div className="col-xs-12 col-md-6">
									<div className="input-wrap">
										<label>Usuario</label>
										<span className={this.state.inputUsuarioActive}>
											<input maxLength="50" ref="usr" id="usuario" name="usuario" defaultValue={this.props.usuario} type="text" onBlur={this.handleBlur}
												onFocus={this.handleFocus} onKeyPress={this._handleKeyPress} onChange={this.handleChange} />
										</span>
										{this.state.errorusuario &&
											<div className="error-wrap">
												<div className="msj-error">
													<p>{this.state.errorUsuarioMsj}</p>
												</div>
											</div>
										}
									</div>
								</div>
								<div className="col-xs-12 col-md-6">
									<div className="input-wrap">
										<label>Confirmar usuario</label>
										<span className={this.state.inputUsuarioConfirmActive}>
											<input maxLength="50" ref="usrC" name="usuarioConfirm" id="usuarioConfirm" defaultValue={this.props.usuario} type="text" onBlur={this.handleBlur} onFocus={this.handleFocus} onKeyPress={this._handleKeyPress} onChange={this.handleChange} />
										</span>
										{this.state.errorusuarioC &&
											<div className="error-wrap">
												<div className="msj-error">
													<p>{this.state.errorUsuarioCMsj}</p>
												</div>
											</div>
										}
									</div>
								</div>
							</div>
						}
					</div>
					<div className="clearfix">
						<div className="col-xs-12 col-md-6 mt-10">
							<h6>
								<i><img src={require("../img/icon-cellphone.svg")} /></i>Teléfono celular
								<span className='orange-tooltip'>
									<button type='button' className='btn btn-primary btn-lg' data-toggle='modal' data-target='#modal-celular' >?</button>
								</span>
							</h6>
							<div className="row">
								<div className="col-md-4 col-xs-3">
									{!this.props.editing &&
										<div className="input-wrap">
											<label>Lada</label>
											<span className="blue-text">
												<p><b>{this.props.lada}</b></p>
											</span>
										</div>
									}
									{this.props.editing &&
										<div className="input-wrap">
											<label>Lada</label>
											<span className={this.state.inputLadaActive}>
												<input maxLength="4" ref="ld" id="lada" defaultValue={this.props.lada} type="text" onBlur={this.handleBlur} onFocus={this.handleFocus} onKeyPress={this._handleKeyPress} onChange={this.handleChange} />
											</span>
										</div>
									}
								</div>
								<div className="col-md-8 col-xs-9">
									{!this.props.editing &&
										<div className="input-wrap">
											<label>Teléfono</label>
											<span className="blue-text">
												<p><b>{this.props.celular}</b></p>
											</span>
										</div>
									}
									{this.props.editing &&
										<div className="input-wrap">
											<label>Teléfono</label>
											<span className={this.state.inputCelularActive}>
												<input maxLength="10" ref="cel" id="celular" defaultValue={this.props.celular} type="text" onBlur={this.handleBlur}
													onFocus={this.handleFocus} onKeyPress={this._handleKeyPress} onChange={this.handleChange} />
											</span>
											{this.state.errorcelular &&
												<div className="error-wrap">
													<div className="msj-error">
														<p>{this.state.errorCelMsj}</p>
													</div>
												</div>
											}
										</div>
									}
								</div>
							</div>
						</div>
						<div className="col-xs-12 col-md-6 mt-10">
							<h6>
								<i><img src={require("../img/icon-phone.svg")} /></i>Teléfono fijo
							</h6>
							<div className="row">
								<div className="col-md-4 col-xs-3">
									{!this.props.editing &&
										<div className="input-wrap">
											<label>Lada</label>
											<span className="blue-text">
												<p><b>{this.props.ladaFijo}</b></p>
											</span>
										</div>
									}
									{this.props.editing &&
										<div className="input-wrap">
											<label>Lada</label>
											<span className={this.state.inputLadaFijoActive}>
												<input maxLength="4" ref="ldF" id="ladaFijo" defaultValue={this.props.ladaFijo} type="text" onBlur={this.handleBlur} onFocus={this.handleFocus} onKeyPress={this._handleKeyPress} onChange={this.handleChange} />
											</span>
										</div>
									}
								</div>
								<div className="col-md-8 col-xs-9">
									{!this.props.editing &&
										<div className="input-wrap">
											<label>Teléfono</label>
											<span className="blue-text">
												<p><b>{this.props.telefono}</b></p>
											</span>
										</div>
									}
									{this.props.editing &&
										<div className="input-wrap">
											<label>Teléfono</label>
											<span className={this.state.inputTelefonoActive}>
												<input maxLength="8" ref="tel" id="telefono" defaultValue={this.props.telefono} type="text" onBlur={this.handleBlur}
													onFocus={this.handleFocus} onKeyPress={this._handleKeyPress} onChange={this.handleChange} />
											</span>
											{this.state.errortelefono &&
												<div className="error-wrap">
													<div className="msj-error">
														<p>{this.state.errorTelMsj}</p>
													</div>
												</div>
											}
										</div>
									}
								</div>
							</div>
						</div>
					</div>
					<div className="clearfix">
						<div className="col-xs-12 col-md-6 mt-25">
							{!this.props.editing &&
								<div className="input-wrap">
									<label>Ocupación</label>
									<span className="blue-text">
										<p><b>{this.props.ocupacion.length > 14 ? this.props.ocupacion.substring(0, 14) + "..." : this.props.ocupacion}</b></p>
									</span>
								</div>
							}
							{this.props.editing &&
								<div className="input-wrap">
									<label>Ocupación</label>
									<span className={this.state.inputOcupacionActive}>
										<input maxLength="50" ref="ocu" id="ocupacion" defaultValue={this.props.ocupacion} type="text" onBlur={this.handleBlur} onFocus={this.handleFocus} onKeyPress={this._handleKeyPress} onChange={this.handleChange} />
									</span>
									{this.state.errorocupacion &&
										<div className="error-wrap">
											<div className="msj-error">
												<p>No se pueden guardar solo espacios.</p>
											</div>
										</div>
									}
								</div>
							}
						</div>
						<div className="col-xs-12 col-md-6 mt-25">
							{!this.props.editing &&
								<div className="input-wrap">
									<label>Área de interés</label>
									<span className="blue-text">
										<p><b>{this.props.areaDeInteres ? areas[this.props.areaDeInteres - 1].area : ''}</b></p>
									</span>
								</div>
							}
							{this.props.editing &&
								<div className="input-wrap">
									<label>Área de interés</label>
									<span className="clearfix input-active">
										<select ref="aI" defaultValue={this.props.areaDeInteres} name="" id="areaDeInteres" className="col-xs-1" onChange={this.setSelectValue}>
											<option value="">Selecciona una opción</option>
											{Areas.map(MakeItem)}
										</select>
									</span>
									{this.state.errorarea &&
										<div className="error-wrap">
											<div className="msj-error">
												<p>Obligatorio</p>
											</div>
										</div>
									}
								</div>
							}
						</div>
					</div>
				</div>
			</div>
			<div className="modal fade modal-msj" id="modal-codigo-dp" tabIndex="-1" role="dialog" aria-labelledby="modal-codigo-dpLabel" data-backdrop="static" data-keyboard="false">
				<div className="modal-dialog" role="document">
					<div className="modal-content">
						<ModalCodigoVerificacion />
					</div>
				</div>
			</div>
			
			<div className='modal fade' id='modal-celular' tabIndex='-1' role='dialog' aria-labelledby='modal-celularLabel'>
				<div className='modal-dialog' role="document">
					<div className='modal-content'>
						<div className='modal-header'>
							<h4 className='modal-title orange-text' id='modal-celularLabel'>Establecer teléfono de contacto</h4>
						</div>
						<div className='modal-body'>
							<p>El teléfono celular será utilizado como medio de contacto para notificarte operaciones realizadas o enviarte códigos de verificación requeridos en algunas transacciones.</p>
						</div>
						<div className='modal-footer'>
							<button type='button' className='btn orange-btn' data-dismiss='modal'>Aceptar</button>
						</div>
					</div>
				</div>
			</div>
			<div className='modal fade' id='modal-validacion1' tabIndex='-1' role='dialog' aria-labelledby='modal-validacion1Label'>
				<div className='modal-dialog' role="document">
					<div className='modal-content'>
						<div className='modal-header'>
							<h4 className='modal-title orange-text' id='modal-validacion1Label'>{this.state.tituloOne}</h4>
						</div>
						<div className='modal-body'>
							<p>{this.state.mensajeOne}</p>
						</div>
						<div className='modal-footer'>
							<button type='button' className='btn orange-btn' data-dismiss='modal'>Aceptar</button>
						</div>
					</div>
				</div>
			</div>
			<div className='modal fade' id='modal-validacion2' tabIndex='-1' role='dialog' aria-labelledby='modal-validacion2Label'>
				<div className='modal-dialog' role="document">
					<div className='modal-content'>
						<div className='modal-header'>
							<h4 className='modal-title orange-text' id='modal-validacion2Label'>{this.state.tituloTwo}</h4>
						</div>
						<div className='modal-body'>
							<p>{this.state.mensajeTwo}</p>
						</div>
						<div className='modal-footer'>
							<button type='button' className='btn orange-btn' data-dismiss='modal' onClick={this.continuar}>Continuar</button>
						</div>
					</div>
				</div>
			</div>

		</div>
	}
}

export default connect(mapState, mapDispatch)(DatosPersonales);


// WEBPACK FOOTER //
// ./src/miPerfil/datosPersonales.cmpt.js